import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import React, { useState } from "react";
import { ProcedureDetail } from "@10x/tabu-mobile-api/dist/requests/entity";

export interface ITabuRequestContext {
	property?: AssetCard;
	properties: AssetCard[];
	addProperty: ( p: AssetCard ) => void;
	addProperties: ( p: AssetCard[] ) => void;
	removeProperty: ( p: AssetCard ) => void;
	reqDetails?: ProcedureDetail;
	setReqDetails: ( details?: ProcedureDetail ) => void;
	reset: () => void;
}

const defContext: ITabuRequestContext = {
	properties: [],
	addProperty: () => {
	},
	addProperties: () => {
	},
	removeProperty: () => {
	},
	setReqDetails: () => {

	},
	reset: () => {

	},
};

export const TabuRequestContext = React.createContext( defContext );

function TabuRequestCW( props: { children?: React.ReactNode } ) {
	const [ property, setProperty ] = useState<AssetCard>();
	const [ properties, setProperties ] = useState<AssetCard[]>( [] );
	const [ reqDetails, setReqDetails ] = useState<ProcedureDetail>();

	const addProperty = ( property: AssetCard ) => {
		setProperty( property );
	};

	const addProperties = ( properties: AssetCard[] ) => {
		setProperties( properties );
	};

	const removeProperty = ( property: AssetCard ) => {
		setProperties( properties.filter( p => p.propertyId !== property.propertyId ) );
	};

	const reset = () => {
		setProperty( undefined );
		setProperties( [] );
		setReqDetails( undefined );
	};

	return <TabuRequestContext.Provider
		value={ {
			property, addProperty,
			properties, addProperties, removeProperty,
			reqDetails, setReqDetails, reset,
		} }>
		{ props.children }
	</TabuRequestContext.Provider>;
}

export default TabuRequestCW;
